/**
 * Back-in-stock request UI — "Email me when available" (blocks/buy-buttons.liquid).
 *
 * When the selected variant is sold out, the buy-buttons block renders a button plus a
 * <dialog data-bis-dialog> holding a native Shopify customer form. Submitting tags the
 * customer with "back-in-stock, BIS-<product-handle>" so the merchant can target them with a
 * segment once the product is restocked. The form is a real (non-AJAX) POST so Shopify's
 * captcha challenge, if triggered, still works; on success Shopify redirects back to the
 * product URL with ?bis=subscribed, which we turn into the dialog's confirmation step.
 *
 * Variant switches only morph the variant picker (see assets/variant-picker.js); like
 * product-form-component, we read the freshly rendered document from the variant:update
 * event payload and swap our sold-out state (class + button + dialog) in or out.
 *
 * Event listeners are delegated on document so they survive any morphing.
 */
(function () {
  function dialogFor(element) {
    var block = element.closest('.buy-buttons-block');
    return block ? block.querySelector('[data-bis-dialog]') : null;
  }

  function setStep(dialog, step) {
    dialog.querySelectorAll('[data-bis-step]').forEach(function (el) {
      el.hidden = el.getAttribute('data-bis-step') !== step;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var opener = target.closest('[data-bis-open]');
    if (opener) {
      // Prefer the Globo "PreOrder | Back in Stock" popup when the app has processed this
      // product form (it sets data-preorder-product-id on it): submissions then live in the
      // app, which auto-emails subscribers on restock. The app only initializes when its
      // "Notify me button" display mode is not Hidden. If Globo is absent or skipped this
      // product, fall back to our customer-tag dialog so no request is ever lost.
      var globo = window.Globo && window.Globo.Preorder;
      var form = opener.closest('form');
      if (
        globo &&
        typeof globo.handleOpenModalBis === 'function' &&
        form &&
        form.hasAttribute('data-preorder-product-id')
      ) {
        globo.handleOpenModalBis(opener);
        return;
      }

      var dialog = dialogFor(opener);
      if (dialog) {
        setStep(dialog, 'form');
        dialog.showModal();
      }
      return;
    }

    var closer = target.closest('[data-bis-close]');
    if (closer) {
      var openDialog = closer.closest('[data-bis-dialog]');
      if (openDialog) openDialog.close();
      return;
    }

    // Light-dismiss: a click on the dialog element itself (not its children) is the backdrop.
    if (target.matches('[data-bis-dialog]') && event.target === target) {
      target.close();
    }
  });

  // Prevent double submits; the form then navigates away (real POST).
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('[data-bis-dialog]')) return;
    var submit = form.querySelector('button[type="submit"]');
    if (submit) {
      submit.setAttribute('disabled', 'true');
      submit.setAttribute('aria-disabled', 'true');
    }
  });

  document.addEventListener('variant:update', function (event) {
    var html = event && event.detail && event.detail.data && event.detail.data.html;
    if (!html) return;

    document.querySelectorAll('.buy-buttons-block').forEach(function (block) {
      // The per-block class (buy-buttons-block--<block.id>) pairs the live block with its
      // counterpart in the freshly rendered document.
      var blockClass = Array.prototype.find.call(block.classList, function (name) {
        return name.indexOf('buy-buttons-block--') === 0 && name !== 'buy-buttons-block--bis';
      });
      if (!blockClass) return;

      var fresh = html.querySelector('.' + CSS.escape(blockClass));
      if (!fresh) return;

      var isBis = fresh.classList.contains('buy-buttons-block--bis');
      block.classList.toggle('buy-buttons-block--bis', isBis);

      var currentButton = block.querySelector('[data-bis-open]');
      var currentDialog = block.querySelector('[data-bis-dialog]');

      if (!isBis) {
        if (currentButton) currentButton.remove();
        if (currentDialog) {
          if (currentDialog.open) currentDialog.close();
          currentDialog.remove();
        }
        return;
      }

      if (!currentButton) {
        var freshButton = fresh.querySelector('[data-bis-open]');
        var buttons = block.querySelector('.product-form-buttons');
        if (freshButton && buttons) buttons.appendChild(document.importNode(freshButton, true));
      }

      if (!currentDialog) {
        var freshDialog = fresh.querySelector('[data-bis-dialog]');
        if (freshDialog) block.appendChild(document.importNode(freshDialog, true));
      }
    });
  });

  // After a successful submission Shopify redirects back with ?bis=subscribed — show the
  // confirmation step once and clean the URL so refreshes don't re-trigger it.
  function showSuccess() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('bis') !== 'subscribed') return;

    params.delete('bis');
    var query = params.toString();
    var cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
    window.history.replaceState({}, '', cleanUrl);

    var dialog = document.querySelector('[data-bis-dialog]');
    if (!dialog) return;
    setStep(dialog, 'success');
    dialog.showModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showSuccess);
  } else {
    showSuccess();
  }
})();
